import React from 'react';
import { View } from 'react-native';
import { LossSummaryProps } from './LossTypes';
import LossCard from './LossCard';
import { styles } from './LossScreen.styles';
import Button from 'src/components/Button/Button';
import NavigationButtons from 'src/features/application/components/NavigationButtons';
import Text from 'src/components/Text/Text';
import LossToast from './LossToast';

const LossSummary: React.FC<LossSummaryProps> = ({
  losses,
  hasLosses,
  userHasLosses,
  setUserHasLosses,
  onAddLoss,
  onEditLoss,
  onDeleteLoss,
  onNext,
  onBack,
  toastVisible,
  lossDeleteErrorToast,
  lossDeleteSuccessToast,
}) => {
  // Handlers for Yes/No buttons
  const handleSelectYes = () => setUserHasLosses(true);
  const handleSelectNo = () => setUserHasLosses(false);

  return (
    <View style={styles.summaryContainer}>
      <Text variant="h2">Losses</Text>

      {/* Yes/No Buttons */}
      {losses.length === 0 && (
        <View style={styles.switchButtonsContainer}>
          <Text variant="title2">Have you had any losses in the past?</Text>
          <View style={styles.switchButtons}>
            <Button
              testID={'final-losses-in-past-yes-btn'}
              title="Yes"
              type={userHasLosses ? 'secondary' : 'tertiary'}
              onPress={handleSelectYes}
              style={styles.switchButton}
            />
            <Button
              testID={'final-losses-in-past-no-btn'}
              title="No"
              type={!userHasLosses ? 'secondary' : 'tertiary'}
              colorVariant={hasLosses ? 'disabled' : 'default'} // Disabled if hasLosses is true
              disabled={hasLosses} // Disable the "No" button if there are losses in Redux
              onPress={handleSelectNo}
              style={styles.switchButton}
            />
          </View>
        </View>
      )}

      {/* Loss Cards */}
      {userHasLosses &&
        losses.map((loss, index) => (
          <LossCard
            key={index}
            loss={loss}
            index={index}
            onEdit={onEditLoss}
            onDelete={onDeleteLoss}
          />
        ))}

      {/* Add Loss Button */}
      {userHasLosses && (
        <Button
          testID={'final-losses-in-past-add-loss-btn'}
          title="+ Add Loss"
          type="tertiary"
          onPress={onAddLoss}
          style={styles.addLossButton}
        />
      )}

      {/* Navigation Buttons */}
      <View style={styles.summaryButtomContainer}>
        <LossToast
          toastVisible={toastVisible}
          lossDeleteErrorToast={lossDeleteErrorToast}
          lossDeleteSuccessToast={lossDeleteSuccessToast}
        />

        <NavigationButtons
          testID={'final-losses-in-past-btn'}
          onBack={onBack}
          onNext={onNext}
          isNextDisabled={userHasLosses && losses.length === 0} // Disable "Next" if userHasLosses is true but no losses exist
        />
      </View>
    </View>
  );
};

export default LossSummary;
